import TimelogsDashboard from './TimelogsDashboard';

export default TimelogsDashboard;
